module.exports = __webpack_public_path__ + "0579fff081749f97a0b66b466038c044.pdf";